import { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";
//import Notifications from "./Notifications";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import smilelogo from "../assets/images/smile_logo.png";
import eutracker_1logo from "../assets/images/eutracker_1logo.png";
import eurologo from "../assets/images/euro.png";
import {
  Avatar,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Dropdown, Image, Menu, Popover } from "antd";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { ArrowDropDown } from "@mui/icons-material";
import axios from "axios";
import { Select as AntSelect } from "antd"; // Import Ant Design components
import colors from "./constants/Colors";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const { Option } = AntSelect;

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    width: "100%",
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const routeNameMap = {
  "/": "Home",
  "/about": "About",
  "/contact": "Contact",
  "/variable": "Variables",
  "/monitoring": "Monitoring",
  "/projects": "Projects",
  "/impact": "Impacts",
};

const items = [
  {
    key: "en",
    label: "English",
    href: "",
    flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/langfr-225px-Flag_of_the_United_Kingdom_%283-5%29.svg.png", // Replace with the actual path or URL of the image
  },
  {
    key: "fr",
    label: "French",
    href: "",
    flag: "https://www.larousse.fr/encyclopedie/data/images/1009493-Drapeau_de_la_France.jpg",
  },
  {
    key: "de",
    label: "German",
    href: "",
    flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Germany_%283-2%29.svg/220px-Flag_of_Germany_%283-2%29.svg.png",
  },
];

export default function Navbar(props) {
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(
    () => localStorage.getItem("project_id") || ""
  );
  const [storedOrganisationName, setStoredOrganisationName] = useState(
    localStorage.getItem("organisation_name")?.toLowerCase() || ""
  );
  const [profile, setProfile] = useState(null);
  const [project, setProject] = useState(null);
  const [openPopover, setOpenPopover] = useState();

  const token = localStorage.getItem("access_token"); // Retrieve token from localStorage or other secure storage

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/user/getProfile/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Assuming you store the token in localStorage
            },
          }
        );
        setProfile(response.data.user);
        console.log("profile", response.data.user);
        localStorage.setItem("is_admin", response.data.user.is_admin);
      } catch (err) {
        console.log("Failed to fetch profile");
      }
    };

    fetchProfile();
  }, []);

  const location = useLocation();
  const path = location.pathname;
  const isSelectedHome = path === "/";
  const isSelectedAbout = path === "/about";
  const isSelectedContact = path === "/contact";

  const isSelectedVariables = path === "/variable";
  const isSelectedMonitoring = path === "/monitoring";
  const isSelectedImpact = path === "/impact";

  const isSelectedProject = path === "/projects";
  const isSelectedDefinepartner = path === "/define_partners";

  const role = localStorage.getItem("role");

  const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const { content } = props;
  const { t, i18n } = useTranslation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const languageMenu = (
    <Menu>
      {items.map((lang) => (
        <Menu.Item key={lang.key}>
          {/* onClick={() => changeLanguage(lang.label)}> */}
          <img
            src={lang.flag}
            style={{ marginRight: 8, width: 10, height: 10 }}
            alt={`${lang.label} flag`}
          />
          {lang.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        console.log("projectsss");
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/projects/"
        );
        console.log("responsesss", response);

        const data = response.data;
        console.log("projects", response.data);
        const storedOrganisationName = Number(
          localStorage.getItem("organisation_name")
        );

        const filteredProjects = data.filter((project) => {
          console.log("test", project.moderator === storedOrganisationName);
          const isCoordinator =
            project.coordinator &&
            project.coordinator === storedOrganisationName;
          /*    project.coordinator_details &&
            (Array.isArray(project.coordinator_details)
              ? project.coordinator_details.some(
                  (detail) => detail.id === storedOrganisationName
                )
              : project.coordinator_details.id === storedOrganisationName);
 */
          const isMember =
            Array.isArray(project.members_details) &&
            project.members_details.some(
              (detail) => detail.id === storedOrganisationName
            );

          const isModerator =
            project.moderator && project.moderator === storedOrganisationName;
          /*     (Array.isArray(project.moderator_details)
              ? project.moderator_details.some((detail) => detail.id === 1)
              : project.moderator_details.id === storedOrganisationName);
 */
          console.log("projecry", selectedProjectId);
          console.log("filtzr", selectedProjectId);

          return isCoordinator || isMember || isModerator;
        });
        console.log("filtzr&1", filteredProjects, selectedProjectId);

        // Update state with filtered projects or all projects if the user is an admin
        if (profile && profile.is_admin === false) {
          console.log("filtzr&2", filteredProjects, selectedProjectId);

          setProjects(filteredProjects);
          if (filteredProjects.length > 0 && !selectedProjectId) {
            console.log("filtzr&3", filteredProjects, filteredProjects[0].id);

            setSelectedProjectId(filteredProjects[0].id);
            handleProjectChange({ target: { value: filteredProjects[0].id } }); // Automatically select the first project
            console.log("filtzr&3", filteredProjects, selectedProjectId);
            // window.location.href = "/projects";
          }
        }
        if (profile && profile.is_admin === true) {
          setProjects(data);
          if (data.length > 0 && !selectedProjectId) {
            console.log("filtzradmin", data[0].id);

            handleProjectChange({ target: { value: data[0].id } }); // Automatically select the first project
          }
        }
      } catch (error) {
        console.error(
          "Error fetching projects:",
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchProjects();
  }, [profile, selectedProjectId]);

  /* useEffect(() => {
    if (selectedProjectId) {
      handleProjectChange({ target: { value: selectedProjectId } });
    }
  }, [selectedProjectId]);
 */
  // Handle project change
  const handleProjectChange = (event) => {
    console.log("hello", event.target.value, projects);
    const selectedId = event.target.value;
    const selectedProject = projects.find(
      (project) => project.id === Number(selectedId)
    );
    console.log("hello2", event.target.value, selectedProject);

    if (selectedProject) {
      const storedOrganisationName = Number(
        localStorage.getItem("organisation_name")
      );

      localStorage.setItem("logo", selectedProject.imageURL);
      console.log("Selected Project:", selectedProject, storedOrganisationName);
      console.log("Selected color:", selectedProject.color);

      let userRole = "none";

      if (
        selectedProject.coordinator &&
        selectedProject.coordinator === storedOrganisationName
      ) {
        userRole = "coordinator";
      }

      if (selectedProject.members_details) {
        const memberNames = selectedProject.members_details.map(
          (detail) => detail.id
        );

        if (memberNames.includes(storedOrganisationName)) {
          userRole = "member";
        }
      }

      if (
        selectedProject.moderator &&
        selectedProject.moderator === storedOrganisationName
      ) {
        userRole = "moderator";
      }

      if (
        selectedProject.moderator_details &&
        selectedProject.coordinator_details
      ) {
        const moderatorNames = Array.isArray(selectedProject.moderator_details)
          ? selectedProject.moderator_details.map((detail) =>
              detail.name.toLowerCase()
            )
          : [selectedProject.moderator_details.name.toLowerCase()];

        const coordinatorNames = Array.isArray(
          selectedProject.coordinator_details
        )
          ? selectedProject.coordinator_details.map((detail) =>
              detail.name.toLowerCase()
            )
          : [selectedProject.coordinator_details.name.toLowerCase()];

        if (
          moderatorNames.includes(storedOrganisationName) &&
          coordinatorNames.includes(storedOrganisationName)
        ) {
          userRole = "coordinator";
        }
      }

      window.location.href = "/";

      localStorage.setItem("project_id", selectedProject.id);
      localStorage.setItem("project_name", selectedProject.name);
      localStorage.setItem("role", userRole);
      console.log("cloororr", selectedProject.color);
      localStorage.setItem("project_color", selectedProject.color);

      setSelectedProjectId(selectedProject.id);
    } else {
      localStorage.removeItem("project_id");
      localStorage.removeItem("role");
      setSelectedProjectId("");
    }
  };

  // Initialize selected project ID from localStorage
  useEffect(() => {
    const storedProjectId = localStorage.getItem("project_id");
    if (storedProjectId) {
      setSelectedProjectId(storedProjectId);
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    navigate("/login");
    setOpenPopover(false);
  };
  const toProfile = () => {
    navigate("/profile");
    setOpenPopover(false);
  };

  const popoverContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 120,
      }}
    >
      <Button type="primary" onClick={toProfile} style={{ marginTop: "8px" }}>
        Profile
      </Button>
      <Button type="primary" onClick={logout} style={{ marginTop: "8px" }}>
        Logout
      </Button>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", width: "85%" }}>
      <CssBaseline />
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100%"
        zIndex={1300}
        sx={{
          backgroundColor: "white",
          boxShadow: "0px 2px 1px rgba(0,0,0,0.1)",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Grid container alignItems="center">
            <Grid item>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(open && { display: "none" }) }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid
              item
              sx={{
                // backgroundColor: "red",
                height: 50,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image src={eutracker_1logo} preview={false} width={170} />
            </Grid>

            {/* <Grid item>
              <Typography variant="h6" noWrap component="div">
                
                <Box
                  component="img"
                  src={eutracker_1logo}
                  // src={`https://eutracker-files.s3.eu-west-3.amazonaws.com/projects/${localStorage.getItem(
                  //   "project_id"
                  // )}_logo.png`}
                  alt="logo"
                  sx={{
                    position: "absolute",
                    top: 5,
                    maxWidth: "100%",
                    maxHeight: "100%", 
                    width: 130,
                    height: "auto",
                    objectFit: "contain",
                    marginBottom: 0,
                    marginRight: 1,
                  }}
                />
              </Typography>
            </Grid> */}
          </Grid>

          {profile && (
            <Grid
              item
              sx={{ display: "flex", alignItems: "center", marginRight: 3 }}
            >
              {/* <Notifications/> */}
              <Grid
                item
                sx={{
                  height: 50,
                  width: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 3,
                  overflow: "hidden", // Coupe ce qui dépasse
                  borderRadius: "8px", // Coins arrondis
                  border: "2px solid #ccc", // Bordure grise légère
                }}
              >
                <Box
                  component="img"
                  src={`https://eutracker-files.s3.eu-west-3.amazonaws.com/projects/${localStorage.getItem(
                    "project_id"
                  )}_logo.png`}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain", // Changed from "cover" to "contain" to show the full logo
                  }}
                />
              </Grid>

              <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
                <InputLabel id="project-select-label">
                  Select a Project
                </InputLabel>
                <Select
                  labelId="project-select-label"
                  value={selectedProjectId}
                  onChange={handleProjectChange}
                  label="Select a Project"
                >
                  {projects.length > 0 ? (
                    projects.map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No projects available</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Popover
              content={popoverContent}
              open={openPopover}
              onOpenChange={setOpenPopover}
              trigger="click"
            >
              <Grid
                sx={{
                  display: "flex",
                  padding: 1,
                  borderRadius: 7,
                  cursor: "pointer",
                  color: "white",
                }}
              >
                <Tooltip title="Open settings" style={{ marginRight: 0 }}>
                  <IconButton sx={{ p: 0 }}>
                    <Avatar src="https://eutracker-files.s3.eu-west-3.amazonaws.com/avatars/Admin.png" />
                  </IconButton>
                </Tooltip>
                <Grid sx={{ width: 100 }}>
                  <Typography
                    variant="body2"
                    style={{ marginBottom: "8px", color: "gray" }}
                  >
                    {profile && profile.firstname && profile.lastname
                      ? `${profile.firstname
                          .charAt(0)
                          .toUpperCase()}${profile.firstname.slice(
                          1
                        )} ${profile.lastname.charAt(0).toUpperCase()}`
                      : "Guest"}
                  </Typography>
                  {profile && profile.is_admin === false ? (
                    role ? ( // Check if role exists
                      <Typography
                        style={{
                          fontWeight: "500",
                          fontStyle: "oblique",
                          color: colors.primary,
                          marginTop: -8,
                        }}
                        variant="body2"
                      >
                        {`${role.charAt(0).toUpperCase()}${role.slice(1)}`}
                      </Typography>
                    ) : (
                      <Typography
                        style={{
                          fontWeight: "500",
                          fontStyle: "oblique",
                          color: colors.primary,
                          marginTop: -8,
                        }}
                        variant="body2"
                      >
                        N/A
                      </Typography>
                    )
                  ) : (
                    <Typography
                      style={{
                        fontWeight: "500",
                        fontStyle: "oblique",
                        marginTop: -8,
                        color: colors.primary,
                        fontSize: 12,
                      }}
                      variant="body2"
                    >
                      Administrator
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Popover>
            <Dropdown
              overlay={languageMenu}
              defaultOpenKeys
              placement="bottomRight"
              arrow
            >
              <Button>
                <img
                  src="https://media.istockphoto.com/id/1223791674/fr/vectoriel/drapeau-du-royaume-uni-t%C3%A9l%C3%A9chargeable.jpg?s=612x612&w=0&k=20&c=K-ZNvVdtzWZHDAmLhYT9mThz6vqLmgnOXY3JzeE-6pk="
                  style={{ marginRight: 8, width: 20, height: 20 }}
                  alt="English flag"
                />
                {i18n.language} <ArrowDropDown />
              </Button>
            </Dropdown>
          </Grid>
        </Toolbar>
      </Box>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            backgroundColor: "white",
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader sx={{ zIndex: 1201 }}>
          <IconButton
            style={{ marginTop: 90, marginBottom: 10 }}
            onClick={handleDrawerClose}
          >
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon fontSize="medium" />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        {/* <Divider /> */}
        <List sx={{ mt: 2 }}>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/"
              selected={isSelectedHome}
              style={{
                ...(isSelectedHome && { backgroundColor: colors.primary }),
              }}
            >
              <ListItemIcon>
                <HomeIcon
                  style={{
                    color: isSelectedHome ? "white" : colors.secondary,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: "Poppins",
                      color: isSelectedHome ? "white" : colors.secondary,
                    }}
                  >
                    Home
                  </span>
                }
              />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/monitoring"
              selected={isSelectedMonitoring}
              style={{
                ...(isSelectedMonitoring && {
                  backgroundColor: colors.primary,
                }),
              }}
            >
              <ListItemIcon>
                <BackupTableIcon
                  style={{
                    color: isSelectedMonitoring ? "white" : colors.secondary,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: "Poppins",
                      color: isSelectedMonitoring ? "white" : colors.secondary,
                    }}
                  >
                    Monitoring
                  </span>
                }
              />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/projects"
              selected={isSelectedProject}
              style={{
                ...(isSelectedProject && { backgroundColor: colors.primary }),
              }}
            >
              <ListItemIcon>
                <HomeIcon
                  style={{
                    color: isSelectedProject ? "white" : colors.secondary,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: "Poppins",
                      color: isSelectedProject ? "white" : colors.secondary,
                    }}
                  >
                    Projects
                  </span>
                }
              />
            </ListItemButton>
          </ListItem>
          {role === "none" ? (
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/impacts"
                selected={isSelectedImpact}
                style={{
                  ...(isSelectedImpact && {
                    backgroundColor: colors.primary,
                  }),
                }}
              >
                <ListItemIcon>
                  <TrendingUpIcon
                    style={{
                      color: isSelectedImpact ? "white" : colors.secondary,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span
                      style={{
                        fontFamily: "Poppins",
                        color: isSelectedImpact ? "white" : colors.secondary,
                      }}
                    >
                      Impacts{" "}
                      <span
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          fontSize: "0.7rem",
                          fontWeight: "bold",
                          padding: "2px 6px",
                          borderRadius: "8px",
                          marginLeft: "8px",
                        }}
                      >
                        NEW
                      </span>
                    </span>
                  }
                />
              </ListItemButton>
            </ListItem>
          ) : (
            <>
              <ListItem disablePadding>
                <ListItemIcon>
                  <TrendingUpIcon
                    style={{
                      color: isSelectedImpact ? "white" : colors.secondary,
                      marginLeft: 14,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span
                      style={{
                        fontFamily: "Poppins",
                        color: isSelectedImpact ? "white" : colors.secondary,
                        marginLeft: 14,
                      }}
                    >
                      Impacts{" "}
                      <span
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          fontSize: "0.7rem",
                          fontWeight: "bold",
                          padding: "2px 6px",
                          borderRadius: "8px",
                          marginLeft: "8px",
                        }}
                      >
                        NEW
                      </span>
                    </span>
                  }
                />
              </ListItem>
            </>
          )}

          {role === "member" ? (
            <></>
          ) : (
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/define_partners"
                selected={isSelectedDefinepartner}
                style={{
                  ...(isSelectedDefinepartner && {
                    backgroundColor: colors.primary,
                  }),
                }}
              >
                <ListItemIcon>
                  <BorderColorIcon
                    style={{
                      color: isSelectedDefinepartner
                        ? "white"
                        : colors.secondary,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span
                      style={{
                        fontFamily: "Poppins",
                        color: isSelectedDefinepartner
                          ? "white"
                          : colors.secondary,
                      }}
                    >
                      Define partners
                    </span>
                  }
                />
              </ListItemButton>
            </ListItem>
          )}

          {role === "member" ? (
            <></>
          ) : (
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/variable"
                selected={isSelectedVariables}
                style={{
                  ...(isSelectedVariables && {
                    backgroundColor: colors.primary,
                  }),
                }}
              >
                <ListItemIcon>
                  <BorderColorIcon
                    style={{
                      color: isSelectedVariables ? "white" : colors.secondary,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span
                      style={{
                        fontFamily: "Poppins",
                        color: isSelectedVariables ? "white" : colors.secondary,
                      }}
                    >
                      Variables
                    </span>
                  }
                />
              </ListItemButton>
            </ListItem>
          )}
          {/* <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/about"
              selected={isSelectedAbout}
              style={{
                ...(isSelectedAbout && { backgroundColor: colors.primary }),
              }}
            >
              <ListItemIcon>
                <InfoIcon
                  style={{
                    color: isSelectedAbout ? "white" : colors.secondary,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: "Poppins",
                      color: isSelectedAbout ? "white" : colors.secondary,
                    }}
                  >
                    About
                  </span>
                }
              />
            </ListItemButton>
          </ListItem> */}
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/contact"
              selected={isSelectedContact}
              style={{
                ...(isSelectedContact && { backgroundColor: colors.primary }),
              }}
            >
              <ListItemIcon>
                <ContactMailIcon
                  style={{
                    color: isSelectedContact ? "white" : colors.secondary,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: "Poppins",
                      color: isSelectedContact ? "white" : colors.secondary,
                    }}
                  >
                    Contact
                  </span>
                }
              />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
        <ListItem disablePadding>
          <ListItemButton onClick={logout} component={Link} to="/login">
            <ListItemIcon>
              <LogoutOutlinedIcon style={{ color: "gray" }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "600",
                    color: "gray",
                  }}
                >
                  {" "}
                  Log Out
                </span>
              }
            />
          </ListItemButton>
        </ListItem>
        <Box
          component="img"
          src="https://www.rdiup.com/wp-content/uploads/2019/06/logoCBerlin48B-1.svg"
          alt="logo"
          sx={{
            width: "60%",
            height: "auto",
            objectFit: "cover",
            marginTop: 25,
            marginLeft: 5,
          }}
        />
        <Box
          component="img"
          src={eurologo}
          alt="logo"
          sx={{
            width: "50%",
            height: "auto",
            objectFit: "cover",
            marginTop: 2,
            marginLeft: 5,
          }}
        />
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
        <Box width="100%" padding={0}>
          {/* <Toolbar /> */}
          <Grid sx={{ display: "flex", marginBottom: 5 }}>
            <Typography
              variant="h6"
              component="div"
              color="#1a659a"
              gutterBottom
            >
              {/* <ArrowForwardIosIcon sx={{fontSize:18}} />  */}
              {routeNameMap[path]}
            </Typography>
          </Grid>
          {content}
        </Box>
      </Main>
    </Box>
  );
}
